export default {
  elements: {},
  init() {
    this.elements.parent = $('.offences-template-default');
    if (this.elements.parent.length > 0) {

      //for each table
      $('table').each(function() {
        $(this).wrap( "<div class='table-scroller'></div>" );
      });

    }
  },
}



// WEBPACK FOOTER //
// ./scripts/components/mobiletables.js